import { useSelector } from 'react-redux';
import {
	getCountriesData,
	getUserCurrentCity,
	getUserCurrentDistrict,
} from '@/stores/slices/userSlice';
import React, { useState } from 'react';
import { SelectCountry } from '@/components/ui';
import useLadyService from '@/services/LadyService';

const SelectCity = () => {
	const { lang } = useLadyService();
	const [currentActive, setCurrentActive] = useState('');

	const countriesData = useSelector(getCountriesData);
	const currentCity = useSelector(getUserCurrentCity);

	const findCitiesWithDistricts = () => {
		const distCities = countriesData[0]?.[`cz`].cities.filter((city) => {
			if (city?.districts?.length > 0) {
				return city;
			}
		});

		const otherCities = countriesData[0]?.[`cz`].cities.filter((city) => {
			if (city?.districts?.length <= 0) {
				return city;
			}
		});

		return { distCities: distCities, cities: otherCities };
	};

	const isJsdom =
		typeof window !== 'undefined' &&
		window.navigator.userAgent.includes('jsdom');

	if (!isJsdom) {
		return (
			<SelectCountry
				data={countriesData}
				name={'city-create'}
				clazz={`button select-city no-outline`}
				arrowSize={'m'}
				type={'flag'}
				defaultTitle={currentCity.title}
				currentActiveIndex={currentActive}
				isMain={true}
				activeCountry={currentCity.icon}
				setActive={setCurrentActive}
				selectDistrict={true}
			/>
		);
	} else {
		return (
			<p>
				{findCitiesWithDistricts().distCities.map((city) => {
					return (
						<>
							<a
								href={`/${lang}/${city.slug}`}
								key={city.id}
							>
								<b>{city.title || city.name}</b>
							</a>
							<span>{`: `}</span>
							{city?.districts?.map((district) => (
								<>
									<a
										href={`/${lang}/${city.slug}_${district?.slug}`}
									>
										{`${city.title || city.name} - ${district?.name}`}
									</a>
									<span>{` `}</span>
								</>
							))}
							<br />
						</>
					);
				})}
				<a href={lang === 'en' ? '/' : `/${lang}/czechia`}>
					<b>{countriesData[0]?.['cz']?.name}</b>
				</a>
				<span>{`: `}</span>
				{findCitiesWithDistricts().cities.map((city) => {
					return (
						<>
							<a
								href={`/${lang}/${city.slug}`}
								key={city.id}
							>
								{city.title || city.name}
							</a>
							<span>{` `}</span>
						</>
					);
				})}
				{/* {countriesData[0]?.['cz'].cities.map((city) => (
                    <>
                        <a href={`/${lang}/${city.slug}`} key={city.id}><b>{city.title || city.name}</b></a>
                        {city?.districts?.map((district) => (
                            <a href={`/${lang}/${city.slug}_${district?.slug}`}>{city.title || city.name} - {district?.name}</a>
                        ))}
                        <br />
                    </>
                ))} */}
			</p>
		);
	}
};

export default SelectCity;

// deploy
